export const allDogs = [
  {
    name: 'Saul',
    id: 1,
    breed: 'Lab',
    image: `${process.env.PUBLIC_URL}/assets/Saul.jpeg`,
    owner: 'Dave',
    size: 'LG',
    description: 'An energetic lab that loves to play',
  },
  {
    name: 'Goldie',
    id: 2,
    breed: 'Lab',
    image: `${process.env.PUBLIC_URL}/assets/Goldie.jpg`,
    owner: 'Dave',
    size: 'LG',
    description: 'Office mommy dog',
  },
  {
    name: 'Gio',
    id: 3,
    breed: 'Terrier',
    image: `${process.env.PUBLIC_URL}/assets/Gio.jpg`,
    owner: 'Dan',
    size: 'SM',
    description: 'A fluffy terrier mix who runs on treats',
  },
  {
    name: 'Sophie',
    id: 4,
    breed: 'Pit Bull',
    image: `${process.env.PUBLIC_URL}/assets/Sophie.jpg`,
    owner: 'Christina',
    size: 'MD',
    description: 'A brindled pitbull princess',
  },
  {
    name: 'Taro',
    id: 5,
    breed: 'Great Pyrenees',
    image: `${process.env.PUBLIC_URL}/assets/Taro.jpg`,
    owner: 'Sara',
    size: 'XL',
    description: 'A great pyrenees mix often confused with a horse',
  },
  {
    name: 'Gabby',
    id: 6,
    breed: 'Pit Bull',
    image: `${process.env.PUBLIC_URL}/assets/Gabby.jpg`,
    owner: 'Dan',
    size: 'MD',
    description: 'A tutu-flaunting American bulldog/pitbull mix',
  },
  {
    name: 'Percy',
    id: 7,
    breed: 'Husky',
    image: `${process.env.PUBLIC_URL}/assets/Percy.jpg`,
    owner: 'Monica',
    size: 'LG',
    description: 'A wolf-sized pup with piercing blue eyes',
  },
  {
    name: 'Benny',
    id: 8,
    breed: 'Hound',
    image: `${process.env.PUBLIC_URL}/assets/Benny.jpg`,
    owner: 'Brandon',
    size: 'MD',
    description: 'A belly-rub loving hound-mix',
  },
  {
    name: 'Baxter',
    id: 9,
    breed: 'Chihuahua',
    image: `${process.env.PUBLIC_URL}/assets/Baxter.jpg`,
    owner: 'Skip',
    size: 'XS',
    description: 'The eldest, wisest, and tiniest dog of the office',
  },
  {
    name: 'Vyla',
    id: 10,
    breed: 'Poodle',
    image: `${process.env.PUBLIC_URL}/assets/Vyla.jpg`,
    owner: 'Skip',
    size: 'SM',
    description: 'The resident toy and bone hoarder',
  },
]
